/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Pxk_Item_Debt_HintInputs */

const vi_orders_pxk_item_debt_hint = /** @type {(inputs: Orders_Pxk_Item_Debt_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chờ kho nhập bù lô`)
};

/**

* @param {Orders_Pxk_Item_Debt_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const orders_pxk_item_debt_hint = /** @type {((inputs?: Orders_Pxk_Item_Debt_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Pxk_Item_Debt_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_orders_pxk_item_debt_hint(inputs)
});